import React, { useState, useEffect } from 'react'
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
  Fab
} from '@mui/material'
import {
  Home as HomeIcon,
  School as SchoolIcon,
  Settings as SettingsIcon,
  Person as PersonIcon,
  Logout as LogoutIcon,
  Class as ClassIcon,
  Help as HelpIcon,
  Upload as UploadIcon,
  Quiz as QuizIcon,
  EmojiEvents as TrophyIcon,
  Add as AddIcon,
  Group as GroupIcon,
  Translate as TranslateIcon,
  Save as SaveIcon,
  Schedule as ScheduleIcon,
  Star as StarIcon,
  Close as CloseIcon,
  NavigateNext as NextIcon,
  QuestionAnswer as QuestionIcon
} from '@mui/icons-material'
import { signOut } from 'firebase/auth'
import { auth } from '../firebase/config'
import { useAuth } from '../hooks/useAuth'
import toast from 'react-hot-toast'
import TeacherClasses from './TeacherClasses'
import SendDocument from './SendDocument'
import Translate from './Translate'
import Memory from './Memory'
import StudentQuestions from './StudentQuestions'
import MiniQuizCreate from './MiniQuizCreate'
import QuizResults from './QuizResults'
import QuizDetail from './QuizDetail'
import WordTaskCreate from './WordTaskCreate'
import WordTaskResults from './WordTaskResults'
import WordTaskDetail from './WordTaskDetail'
import Schedule from './Schedule'
import Settings from './Settings'
import LevelChoice from './LevelChoice'
import TeacherGhostTutorial from './TeacherGhostTutorial'
import Education from './Education'
import Leaderboard from './Leaderboard'
import SpaceTheme from '../components/SpaceTheme'
import AdPlacement from '../components/AdPlacement'
import { useUrlNavigation } from '../hooks/useUrlNavigation'

const TeacherDashboard = ({ userData, onBack }) => {
  console.log('TeacherDashboard onBack prop:', onBack)
  console.log('TeacherDashboard onBack prop type:', typeof onBack)
  console.log('TeacherDashboard onBack prop toString:', onBack?.toString())
  console.log('TeacherDashboard onBack prop toString length:', onBack?.toString()?.length)
  const { user } = useAuth()
  const [anchorEl, setAnchorEl] = useState(null)

  const [showTutorial, setShowTutorial] = useState(false)
  const [tutorialStep, setTutorialStep] = useState(0)
  const [showProfileDialog, setShowProfileDialog] = useState(false)
  const { currentPage, navigateToPage, goBack } = useUrlNavigation('teacher-dashboard')
  const setCurrentPage = navigateToPage // Eski API uyumluluğu için

  // İlk yüklemede hash yoksa teacher-dashboard hash'i ekle
  useEffect(() => {
    if (!window.location.hash) {
      window.location.hash = 'teacher-dashboard'
    }
  }, [])
  const [quizDetailData, setQuizDetailData] = useState(null)
  const [wordTaskDetailData, setWordTaskDetailData] = useState(null)

  // Avatar için kullanıcı bilgilerini hazırla
  const getAvatarProps = () => {
    if (userData?.profileImageUrl) {
      return { src: userData.profileImageUrl, alt: userData.username }
    }
    
    const displayName = userData?.username || user?.displayName || user?.email?.split('@')[0] || 'U'
    return { 
      children: displayName.charAt(0).toUpperCase(),
      alt: displayName
    }
  }

  const handleLogout = async () => {
    try {
      // Çıkış yapmadan önce hash'i temizle
      window.location.hash = ''
      // URL'yi temizle
      window.history.replaceState(null, '', window.location.pathname)
      
      await signOut(auth)
      toast.success('Başarıyla çıkış yaptınız')
    } catch (error) {
      console.error('Logout error:', error)
      toast.error('Çıkış yapılırken hata oluştu')
    }
  }

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleProfileClick = () => {
    setShowProfileDialog(true)
  }

  const handleGhostHelp = () => {
    setCurrentPage('teacher-ghost-tutorial')
  }

  const handleTutorialNext = () => {
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1)
    } else {
      setShowTutorial(false)
    }
  }

  const handleTutorialSkip = () => {
    setShowTutorial(false)
  }



  const handleBackToDashboard = (data) => {
    if (data && data.page === 'quiz-detail') {
      setCurrentPage('quiz-detail')
      setQuizDetailData({
        quizId: data.quizId,
        quizTitle: data.quizTitle
      })
    } else if (data && data.page === 'word-task-detail') {
      setCurrentPage('word-task-detail')
      setWordTaskDetailData({
        wordTaskId: data.wordTaskId,
        wordTaskTitle: data.wordTaskTitle
      })
    } else if (data && data.page === 'level-choice') {
      setCurrentPage('level-choice')
    } else if (data && data.page === 'education') {
      // Education sayfasına yönlendirme
      setCurrentPage('education')
    } else if (data && data.page === 'leaderboard') {
      // Leaderboard'a yönlendirme
      setCurrentPage('leaderboard')
    } else if (data && data.page === 'settings') {
      // Settings'e yönlendirme
      setCurrentPage('settings')
    } else {
      setCurrentPage('dashboard')
      setQuizDetailData(null)
      setWordTaskDetailData(null)
    }
  }

  // TeacherClasses sayfasını göster
  if (currentPage === 'teacher-classes') {
    return <TeacherClasses userData={userData} onBack={handleBackToDashboard} />
  }

  // SendDocument sayfasını göster
  if (currentPage === 'send-document') {
    return <SendDocument userData={userData} onBack={handleBackToDashboard} />
  }

  // Translate sayfasını göster
  if (currentPage === 'translate') {
    return <Translate userData={userData} onBack={handleBackToDashboard} />
  }

  // Memory sayfasını göster
  if (currentPage === 'memory') {
    return <Memory 
      userData={userData} 
      onBack={handleBackToDashboard}
      onNavigateToTranslate={() => setCurrentPage('translate')}
    />
  }

  // Student Questions sayfasını göster
  if (currentPage === 'student-questions') {
    return <StudentQuestions 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Mini Quiz Create sayfasını göster
  if (currentPage === 'create-quiz') {
    return <MiniQuizCreate 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Quiz Results sayfasını göster
  if (currentPage === 'quiz-results') {
    return <QuizResults 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Quiz Detail sayfasını göster
  if (currentPage === 'quiz-detail' && quizDetailData) {
    return <QuizDetail 
      userData={userData} 
      onBack={handleBackToDashboard}
      quizId={quizDetailData.quizId}
      quizTitle={quizDetailData.quizTitle}
    />
  }

  // Word Task Create sayfasını göster
  if (currentPage === 'word-task-create') {
    return <WordTaskCreate 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Word Task Results sayfasını göster
  if (currentPage === 'word-task-results') {
    return <WordTaskResults 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Word Task Detail sayfasını göster
  if (currentPage === 'word-task-detail' && wordTaskDetailData) {
    return <WordTaskDetail 
      userData={userData} 
      onBack={handleBackToDashboard}
      wordTaskId={wordTaskDetailData.wordTaskId}
      wordTaskTitle={wordTaskDetailData.wordTaskTitle}
    />
  }

  // Schedule sayfasını göster
  if (currentPage === 'schedule') {
    return <Schedule 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Settings sayfasını göster
  if (currentPage === 'settings') {
    return <Settings 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Education sayfasını göster
  if (currentPage === 'education') {
    return <Education 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Leaderboard sayfasını göster
  if (currentPage === 'leaderboard') {
    return <Leaderboard 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Level Choice sayfasını göster
  if (currentPage === 'level-choice') {
    return <LevelChoice 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Teacher Ghost Tutorial sayfasını göster
  if (currentPage === 'teacher-ghost-tutorial') {
    return <TeacherGhostTutorial 
      userData={userData} 
      onBack={handleBackToDashboard}
    />
  }

  // Tutorial adımları
  const tutorialSteps = [
    "Hoşgeldiniz Değerli öğretmenim! 👻\n\nBenim adım Ghost, size başlangıç için yol arkadaşlığı yapacağım. Hazır mısınız?",
    "Bu kartlar ile sınıflarınızı yönetebilir, görevler oluşturabilir ve öğrencilerinizin sonuçlarını detaylı takip edebilirsiniz.",
    "🚪Sınıflarım Kartı\nSınıflar oluşturabilir, onları görüntüleyebilir, öğrenci detaylarını inceleyebilir ve sınıf yönetimini yapabilirsiniz.",
    "❓ Öğrenci Soruları\nÖğrencilerinizin sorularını görüp cevaplayabilirsiniz.",
    "📄 Döküman Gönder\nÖğrencilerinize döküman gönderebilir ve paylaşabilirsiniz.",
    "📝 Mini Quiz Oluştur\nHızlı quizler oluşturup öğrencilerinize gönderebilirsiniz.",
    "📊 Quiz Sonuçları\nÖğrencilerinizin quiz sonuçlarını takip edebilirsiniz.",
    "📚 Kelime Görevi Oluştur\nKelime öğrenme görevleri oluşturup öğrencilerinize gönderebilirsiniz.",
    "📈 Kelime Görevleri Sonuçları\nKelime görevlerinin sonuçlarını takip edebilirsiniz.",
    "📅 Ders Programı\nDers programınızı yönetebilirsiniz. Günlük bildirimler alabilir kendinize not bırakabilirsiniz.",
    "🌐 Çeviri\nHızlı çeviri yapabilir ve bu çevirileri hafızalayabilirsiniz.",
    "🧠 Hafıza\nHafızaladığınız bilgilere buradan ulaşabilir günlük bildirimler alabilirsiniz.",
    "Şimdi eğitim paneli butonuna tıklayarak yolumuza devam edelim! Orada benim görselime tıklayarak detaylı bilgi edinebilirsiniz."
  ]

  // Öğretmen menü kartları - Android uygulamasındaki sırayla
  const teacherMenuItems = [
    {
      id: 'classes',
      title: 'Sınıflarım',
      icon: <ClassIcon sx={{ fontSize: 32, color: 'primary.main' }} />,
      description: 'Sınıflarımı yönet ve öğrencileri görüntüle',
      color: 'primary',
      action: () => 'teacher-classes'
    },
    {
      id: 'student-questions',
      title: 'Öğrenci Soruları',
      icon: <QuestionIcon sx={{ fontSize: 32, color: 'info.main' }} />,
      description: 'Öğrenci sorularını yanıtla',
      color: 'info',
      action: () => 'student-questions'
    },
    {
      id: 'send-document',
      title: 'Döküman Gönder',
      icon: <UploadIcon sx={{ fontSize: 32, color: 'info.main' }} />,
      description: 'Öğrencilere döküman gönder',
      color: 'info',
      action: () => 'send-document'
    },
    {
      id: 'create-quiz',
      title: 'Mini Quiz Oluştur',
      icon: <QuizIcon sx={{ fontSize: 32, color: 'warning.main' }} />,
      description: 'Öğrenciler için quiz oluştur',
      color: 'warning',
      action: () => 'create-quiz'
    },
    {
      id: 'quiz-results',
      title: 'Quiz Sonuçları',
      icon: <TrophyIcon sx={{ fontSize: 32, color: 'success.main' }} />,
      description: 'Quiz sonuçlarını görüntüle',
      color: 'success',
      action: () => 'quiz-results'
    },
    {
      id: 'create-word-task',
      title: 'Kelime Görevi Oluştur',
      icon: <AddIcon sx={{ fontSize: 32, color: 'primary.main' }} />,
      description: 'Öğrenciler için kelime görevi oluştur',
      color: 'primary',
      action: () => 'word-task-create'
    },
    {
      id: 'word-task-results',
      title: 'Kelime Görevleri Sonuçları',
      icon: <StarIcon sx={{ fontSize: 32, color: 'secondary.main' }} />,
      description: 'Kelime görevlerinin sonuçlarını takip et',
      color: 'secondary',
      action: () => 'word-task-results'
    },
    {
      id: 'schedule',
      title: 'Ders Programı',
      icon: <ScheduleIcon sx={{ fontSize: 32, color: 'info.main' }} />,
      description: 'Ders programını yönet',
      color: 'info',
      action: () => 'schedule'
    },
         {
       id: 'translate',
       title: 'Çeviri',
       icon: <TranslateIcon sx={{ fontSize: 32, color: 'warning.main' }} />,
       description: 'Hızlı çeviri yap',
       color: 'warning',
       action: () => 'translate'
     },
     {
       id: 'memory',
       title: 'Hafıza',
       icon: <SaveIcon sx={{ fontSize: 32, color: 'success.main' }} />,
       description: 'Kaydedilen bilgileri görüntüle',
       color: 'success',
       action: () => 'memory'
     }
  ]

  const handleMenuItemClick = (item, event) => {
    event.preventDefault()
    event.stopPropagation()
    
    if (item.action) {
      const newPage = item.action()
      if (newPage) {
        setCurrentPage(newPage)
      }
    }
  }

  return (
    <SpaceTheme>
      {/* App Bar */}
      <AppBar position="static" sx={{ 
        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(79, 172, 254, 0.9)'
      }}>
        <Toolbar>
          {/* Logo */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'white', 
            borderRadius: '50%', 
            width: { xs: 40, sm: 56, md: 66 },
            height: { xs: 40, sm: 56, md: 66 },
            marginRight: { xs: 1, sm: 2 },
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
          }}>
            <img 
              src="/logo.png" 
              alt="EngliX Logo" 
              style={{ 
                width: window.innerWidth < 600 ? 28 : window.innerWidth < 900 ? 40 : 50, 
                height: window.innerWidth < 600 ? 28 : window.innerWidth < 900 ? 40 : 50, 
                objectFit: 'contain'
              }}
              onError={(e) => {
                console.log('Logo yüklenemedi, alternatif yollar deneniyor...')
                // Alternatif logo yollarını dene
                if (e.target.src.includes('logo.png')) {
                  e.target.src = '/logo.jpg'
                } else if (e.target.src.includes('logo.jpg')) {
                  e.target.src = '/logo.svg'
                } else if (e.target.src.includes('logo.svg')) {
                  e.target.src = '/logo.webp'
                } else {
                  e.target.style.display = 'none'
                  console.log('Logo dosyası bulunamadı')
                }
              }}
            />
          </Box>
          
          <Typography variant="h5" component="div" sx={{ 
            flexGrow: 1,
            fontWeight: 'bold',
            letterSpacing: '0.5px',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
            fontSize: { xs: '1rem', sm: '1.5rem' }
          }}>
            EngliX
          </Typography>
          
          {/* Navigation Buttons */}
          {/* Education Button - Her zaman görünür */}
          <IconButton
            color="inherit"
            onClick={() => {
              console.log('Education button clicked, setting currentPage to education')
              setCurrentPage('education')
            }}
            sx={{ mr: 1 }}
          >
            <SchoolIcon />
          </IconButton>
          
          {/* Settings Button - Sadece masaüstü */}
          <IconButton
            color="inherit"
            onClick={() => {
              setCurrentPage('settings')
            }}
            sx={{ 
              mr: { xs: 1, sm: 2 },
              display: { xs: 'none', md: 'flex' }
            }}
          >
            <SettingsIcon />
          </IconButton>
          
          <IconButton
            size="large"
            edge="end"
            color="inherit"
            onClick={handleMenuOpen}
            sx={{
              p: { xs: 0.5, sm: 1 }
            }}
          >
            <Avatar 
              sx={{ 
                width: { xs: 36, sm: 32 }, 
                height: { xs: 36, sm: 32 },
                border: '2px solid rgba(255,255,255,0.5)'
              }}
              {...getAvatarProps()}
            />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleProfileClick}>
              <PersonIcon sx={{ mr: 1 }} />
              Profil
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <LogoutIcon sx={{ mr: 1 }} />
              Çıkış Yap
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Header Card - Android uygulamasındaki gibi */}
      <Card sx={{ 
        mx: { xs: 0.5, sm: 2 }, 
        mt: { xs: 1, sm: 2 }, 
        borderRadius: 3,
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <CardContent sx={{ p: 2.5 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <Avatar
                sx={{ 
                  width: 56, 
                  height: 56, 
                  mr: 2,
                  cursor: 'pointer',
                  border: '3px solid #4facfe',
                  boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)'
                }}
                {...getAvatarProps()}
                onClick={handleProfileClick}
              />
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                  {userData?.username || user?.displayName || 'Öğretmen'}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Öğretmen
                </Typography>
              </Box>
            </Box>
            
            {/* Ghost Help Button */}
            <IconButton
              onClick={handleGhostHelp}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: '#1976d2',
                color: 'white',
                boxShadow: '0 4px 15px rgba(25, 118, 210, 0.4)',
                '&:hover': {
                  backgroundColor: '#1565c0',
                  transform: 'scale(1.1)',
                  transition: 'all 0.2s ease-in-out'
                }
              }}
            >
              <Typography variant="h6">👻</Typography>
            </IconButton>
          </Box>
        </CardContent>
      </Card>

      {/* Native Reklam - Öğretmenler için daha az sıklıkta */}
      <Box sx={{ mx: { xs: 0.5, sm: 2 }, mt: 1.5 }}>
        <AdPlacement 
          type="native" 
          position="content" 
          userRole="teacher"
          pageType="general"
        />
      </Box>

      {/* Main Content */}
      <Container maxWidth="sm" sx={{ 
        py: { xs: 1, sm: 2 },
        px: { xs: 1, sm: 2 }
      }}>
        {/* Menu Items - Android uygulamasındaki sırayla */}
        <List sx={{ px: 0 }}>
          {teacherMenuItems.map((item, index) => (
            <React.Fragment key={item.id}>
              <ListItem
                button
                onClick={() => handleMenuItemClick(item)}
                sx={{
                  borderRadius: 2,
                  mb: 1,
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    transform: 'translateX(4px) scale(1.02)',
                    transition: 'all 0.3s ease-in-out',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
                  }
                }}
              >
                <ListItemIcon>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{
                    variant: 'h6',
                    fontWeight: 'bold',
                    color: '#333'
                  }}
                />
              </ListItem>
              {index < teacherMenuItems.length - 1 && (
                <Divider sx={{ my: 1, backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />
              )}
            </React.Fragment>
          ))}
        </List>
      </Container>

      {/* Bottom Navigation - REMOVED */}

      {/* Profile Image Dialog */}
      <Dialog
        open={showProfileDialog}
        onClose={() => setShowProfileDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent sx={{ textAlign: 'center', p: 4 }}>
          <Avatar
            sx={{ 
              width: 200, 
              height: 200, 
              mx: 'auto',
              mb: 2,
              border: '4px solid #e0e0e0'
            }}
            {...getAvatarProps()}
          />
          <Typography variant="h5" gutterBottom>
            {userData?.username || user?.displayName || 'Öğretmen'}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Öğretmen
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowProfileDialog(false)}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tutorial Overlay */}
      {showTutorial && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 3
          }}
        >
          {/* Speech Bubble */}
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: 3,
              p: 3,
              maxWidth: 400,
              mt: 4,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -10,
                left: 50,
                width: 0,
                height: 0,
                borderLeft: '10px solid transparent',
                borderRight: '10px solid transparent',
                borderTop: '10px solid #fff'
              }
            }}
          >
            <Typography variant="body1" sx={{ textAlign: 'center', lineHeight: 1.6 }}>
              {tutorialSteps[tutorialStep]}
            </Typography>
          </Box>

          {/* Ghost Character */}
          <Typography variant="h1" sx={{ fontSize: 80, mb: 2 }}>
            👻
          </Typography>

          {/* Navigation Buttons */}
          <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
            <Button
              variant="outlined"
              onClick={handleTutorialSkip}
              sx={{ color: '#2196F3', borderColor: '#2196F3' }}
            >
              Atla
            </Button>
            <Button
              variant="outlined"
              onClick={handleTutorialNext}
              sx={{ color: '#2196F3', borderColor: '#2196F3' }}
            >
              Sonraki
            </Button>
          </Box>
        </Box>
      )}
    </SpaceTheme>
  )
}

export default TeacherDashboard
